import React from 'react'
import moment from 'moment'

const getStartMonth = date => {
  return {
    monthyearmoment: date,
    monthyear: {
      month: date.format('MM'),
      year: date.format('YYYY'),
    },
  }
}

const getEndMonth = date => {
  return {
    monthyearendmoment: date,
    monthyearend: {
      month: date.format('MM'),
      year: date.format('YYYY'),
    },
  }
}

const getStartDate = date => {
  return {
    startDate: date,
  }
}

const getEndDate = date => {
  return {
    endDate: date,
  }
}

const getDateStates = (stD, enD) => ({
  ...getStartMonth(stD),
  ...getEndMonth(enD),
  ...getStartDate(stD),
  ...getEndDate(enD),
})

export const getChangeDateSelectionProps = (type, startDate, endDate) => {
  if (type === 0) {
    return {
      ...getDateStates(startDate.clone(), endDate.clone()),
      dateSelectionType: 0,
    }
  } else if (type === 1) {
    // current month
    const std = moment().startOf('month')
    const end = moment().endOf('month')
    return getDateStates(std, end)
  } else if (type === 2) {
    // prev month
    const std = moment()
      .subtract(1, 'month')
      .startOf('month')
    const end = moment()
      .subtract(1, 'month')
      .endOf('month')
    return getDateStates(std, end)
  } else if (type === 3) {
    // curr year
    const std = moment().startOf('year')
    const end = moment().endOf('year')
    return getDateStates(std, end)
  } else if (type === 4) {
    //  year to Date
    const std = moment().startOf('year')
    const end = moment()
    return getDateStates(std, end)
  } else if (type === 5) {
    //  month to Date
    const std = moment().startOf('month')
    const end = moment()
    return getDateStates(std, end)
  } else if (type === 6) {
    //  prev year
    const std = moment()
      .subtract(1, 'year')
      .startOf('year')
    const end = moment()
      .subtract(1, 'year')
      .endOf('year')
    return getDateStates(std, end)
  } else if (type === 7) {
    //  year to month
    const std = moment().startOf('year')
    const end = moment()
    return getDateStates(std, end)
  } else if (type === 8) {
    //  year to last month
    const std = moment().startOf('year')
    const end = moment()
      .subtract(1, 'month')
      .endOf('month')
    return getDateStates(std, end)
  } else if (type === 9) {
    //  trailing 12 month
    const end = moment().endOf('month')
    const std = end
      .clone()
      .subtract(11, 'month')
      // .subtract(1, 'year')
      .startOf('month')
    return getDateStates(std, end)
  } else if (type === 10) {
    //  complete year
    const std = startDate.clone().startOf('year')
    const end = startDate.clone().endOf('year')
    return getDateStates(std, end)
  } else if (type === 11) {
    //  first qua
    const std = startDate.clone().startOf('year')
    const end = std
      .clone()
      .add(2, 'month')
      .endOf('month')
    return getDateStates(std, end)
  } else if (type === 12) {
    //  sec qua
    const std = startDate
      .clone()
      .startOf('year')
      .add(3, 'month')
    const end = std
      .clone()
      .add(2, 'month')
      .endOf('month')
    return getDateStates(std, end)
  } else if (type === 13) {
    //  3rd qua
    const std = startDate
      .clone()
      .startOf('year')
      .add(6, 'month')
    const end = std
      .clone()
      .add(2, 'month')
      .endOf('month')
    return getDateStates(std, end)
  } else if (type === 14) {
    //  4th qua
    const std = startDate
      .clone()
      .startOf('year')
      .add(9, 'month')
    const end = std
      .clone()
      .add(2, 'month')
      .endOf('month')
    return getDateStates(std, end)
  }
}
